import { useAuth } from "@/context/AuthContext";
import { FEATURE_LABELS } from "@/lib/tiers";
import { Lock, Sparkles } from "lucide-react";

export default function UpgradePrompt({ feature }) {
  const { org } = useAuth();
  const label = FEATURE_LABELS[feature] || "This feature";
  const includedIn = org?.feature_tiers?.[feature];
  const currentTier = org?.tier_name;

  return (
    <div className="flex items-center justify-center min-h-[70vh] p-6" data-testid="upgrade-prompt">
      <div className="max-w-md w-full border border-industrial bg-surface p-8 text-center">
        <div className="w-14 h-14 rounded-full bg-primary-orange/15 flex items-center justify-center mx-auto mb-4">
          <Lock className="w-6 h-6 text-primary-orange" />
        </div>
        <h2 className="heading text-xl font-black mb-1">{label} is locked</h2>
        <p className="text-sm text-muted-industrial mb-4">
          {currentTier ? `Your ${currentTier} plan doesn't include ${label}.` : `This feature isn't included in your current plan.`}
          {includedIn ? ` It's available on the ${includedIn} plan and above.` : ""}
        </p>
        <div className="border border-primary-orange/40 bg-primary-orange/5 p-4 mb-5 text-left">
          <div className="flex items-center gap-2 text-primary-orange text-xs uppercase tracking-widest font-bold mb-1">
            <Sparkles className="w-3.5 h-3.5" /> Upgrade to unlock
          </div>
          <div className="text-sm font-bold">{label}{includedIn ? ` — ${includedIn} plan` : ""}</div>
        </div>
        <a
          href="mailto:admin@armorbatch.com?subject=ArmorBatch%20—%20Upgrade%20my%20plan"
          data-testid="upgrade-contact"
          className="inline-block w-full bg-primary-orange text-black font-bold py-3 uppercase tracking-widest text-sm hover:opacity-90"
        >
          Contact us to upgrade
        </a>
      </div>
    </div>
  );
}
